import { configureStore } from '@reduxjs/toolkit';
import UserStore from './UserStore';
import ContractsStore from './ContractsStore';
import NotificationsStore from './NotificationsStore';

export const store = configureStore({
  reducer: {
    user: UserStore,
    contracts: ContractsStore,
    notifications: NotificationsStore,
  },
});

export default store;
